// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-container {
    display: flex;
    justify-content: center;
    align-items: flex-start; 
    margin-top: 5px;
  }
  .dialog-actions {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }




/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm0tcG9wdXAtY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGFBQWE7SUFDYix1QkFBdUI7SUFDdkIsdUJBQXVCO0lBQ3ZCLGVBQWU7RUFDakI7RUFDQTtJQUNFLGFBQWE7SUFDYix5QkFBeUI7SUFDekIscUJBQXFCO0VBQ3ZCIiwiZmlsZSI6ImNvbmZpcm0tcG9wdXAtY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tYXQtZGlhbG9nLWNvbnRhaW5lciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBhbGlnbi1pdGVtczogZmxleC1zdGFydDsgXG4gICAgbWFyZ2luLXRvcDogNXB4O1xuICB9XG4gIC5kaWFsb2ctYWN0aW9ucyB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICAgIGFsaWduLWl0ZW1zOiBmbGV4LWVuZDtcbiAgfVxuXG5cblxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/doa/permanent-doa/confirm-popup/confirm-popup-component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,qBAAqB;EACvB;;;;;AAKF,4rBAA4rB","sourcesContent":[".mat-dialog-container {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start; \n    margin-top: 5px;\n  }\n  .dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
